import(/* webpackMode: "eager", webpackExports: ["default"] */ "/hisea-ssr/src/components/MilitaryDiscountsPage/militaryDiscountsPage.js");
